import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import { CompanyService } from '../../@core/data/company/company.service';
import { ParnersError, ParnersLoaded, ParnersRequested } from './parners.actions';

@Injectable()
export class ParnersEffects {
  constructor(
    private actions$: Actions,
    private companyService: CompanyService
  ) {}

  requestParners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParnersRequested),
      mergeMap(() =>
        this.companyService.getCompanies('').pipe(
          map((res: any) => {
            return res.status ? ParnersLoaded({ parners: res?.data }) : ParnersLoaded({parners: []})
        }),
          catchError((error: any) => of(ParnersError()))
        ) 
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ParnersError),
        tap(() => {
        })
      ),
    { dispatch: false }
  );
}
